'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = HotSvg;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function HotSvg(props) {
    var size = props.size,
        primaryColor = props.primaryColor,
        _props$i18n = props.i18n,
        i18n = _props$i18n === undefined ? { get: function get() {
            return null;
        } } : _props$i18n;


    return _react2.default.createElement(
        'svg',
        { role: 'img', 'aria-labelledby': 'outImgHot', width: size, height: size, viewBox: '0 0 28 28', xmlns: 'http://www.w3.org/2000/svg', 'data-hook': 'wixrest-menus-icon-outline-hot' },
        _react2.default.createElement(
            'title',
            { id: 'outImgHot' },
            i18n.get('openrest_menubuilderv3_dishlabels_hot') || 'hot'
        ),
        _react2.default.createElement(
            'g',
            { fill: primaryColor },
            _react2.default.createElement('path', {
                d: 'M20.208 13.4604c.224 1.195-.873 3.125-2.729 4.804-1.753 1.587-4.851 1.899-5.725 1.625.168-.053.42-.102.621-.141 1.097-.216 2.932-.578 3.959-2.749.416-.882.473-1.753.518-2.453.01-.154.019-.302.033-.441.059-.63.241-1.45.766-1.776.453-.281 1.086-.136 1.536.036.592.226.925.584 1.021 1.095m.979-3.914c-.351-.122-.708-.093-1.03.086-.591.327-.944 1.109-1.127 1.64-.91-.222-1.532-.025-1.907.208-.7.435-1.116 1.286-1.234 2.53-.014.15-.025.307-.035.472-.042.646-.089 1.38-.424 2.09-.811 1.715-2.162 1.98-3.248 2.194-.746.147-1.592.314-1.568 1.179.006.204.096.58.64.812.333.143.808.214 1.366.214 1.67 0 4.069-.644 5.529-1.965 2.17-1.963 3.336-4.159 3.042-5.73-.097-.518-.394-1.191-1.226-1.649.155-.455.41-.972.678-1.121.073-.04.133-.044.216-.016.259.091.546-.047.637-.308.09-.261-.048-.545-.309-.636M11.6211 14.1108c-1.753 1.584-4.851 1.9-5.724 1.624.168-.052.42-.102.622-.142 1.097-.216 2.932-.577 3.958-2.748.416-.88.473-1.749.518-2.447.01-.156.02-.306.033-.447.06-.631.242-1.45.767-1.776.454-.282 1.085-.135 1.535.036.592.227.926.585 1.021 1.096.224 1.195-.874 3.126-2.73 4.804m3.713-4.988c-.097-.518-.394-1.191-1.227-1.65.156-.455.411-.972.679-1.12.074-.039.137-.044.217-.016.257.092.545-.048.637-.309.089-.26-.048-.545-.309-.636-.351-.122-.708-.093-1.029.086-.592.327-.946 1.11-1.128 1.641-.91-.223-1.531-.027-1.907.207-.701.435-1.116 1.286-1.234 2.53-.015.151-.025.311-.036.477-.042.646-.089 1.377-.424 2.085-.81 1.714-2.161 1.98-3.247 2.193-.747.148-1.593.314-1.568 1.18.006.204.096.58.639.813.333.142.808.214 1.366.214 1.669 0 4.069-.645 5.529-1.965 2.17-1.963 3.336-4.158 3.042-5.73' }),
            _react2.default.createElement('path', {
                d: 'M13.6499 25.999c-6.81 0-12.35-5.54-12.35-12.349 0-6.81 5.54-12.35 12.35-12.35s12.35 5.54 12.35 12.35c0 6.809-5.54 12.349-12.35 12.349m0-25.999c-7.527 0-13.65 6.123-13.65 13.65 0 7.526 6.123 13.65 13.65 13.65s13.651-6.124 13.651-13.65c0-7.527-6.124-13.65-13.651-13.65' })
        )
    );
}

HotSvg.displayName = 'HotSvg';
HotSvg.propTypes = {
    size: _propTypes2.default.number,
    primaryColor: _propTypes2.default.string
};
HotSvg.defaultProps = {
    size: 28,
    primaryColor: '#c4270e'
};